<template>
    <ProjectCard/>
    <CurrenciesCard/>
</template>
<script>
import ProjectCard from './cards/ProjectCard.vue';
import CurrenciesCard from './cards/CurrenciesCard.vue';

export default {
    name: "BasicSettingsPage",
    components: {
        ProjectCard, CurrenciesCard
    }
}
</script>
